import React, { useState } from 'react';
import PricingCard from './PricingCard';

const PricingSection: React.FC = () => {
  const [billingPeriod, setBillingPeriod] = useState<'monthly' | 'annual'>('monthly');

  const pricingData = {
    basic: {
      title: 'Basic plan',
      monthlyPrice: 22,
      annualPrice: 220,
      features: [
        { text: '200+ integrations', included: false },
        { text: 'Advanced reporting and analytics', included: false },
        { text: 'Up to 10 individual users', included: true },
        { text: '20GB individual data each user', included: true },
        { text: 'Basic chat and email support', included: true },
      ],
    },
    business: {
      title: 'Business plan',
      monthlyPrice: 40,
      annualPrice: 400,
      features: [
        { text: '200+ integrations', included: true },
        { text: 'Advanced reporting and analytics', included: true },
        { text: 'Up to 20 individual users', included: true },
        { text: '40GB individual data each user', included: true },
        { text: 'Priority chat and email support', included: true },
      ],
    },
    enterprise: {
      title: 'Enterprise plan',
      monthlyPrice: 64,
      annualPrice: 640,
      features: [
        { text: '200+ integrations', included: true },
        { text: 'Advanced reporting and analytics', included: true },
        { text: 'Unlimited individual users', included: true },
        { text: 'Unlimited individual data', included: true },
        { text: 'Personalized + priority service', included: true },
      ],
    },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center">
        <h2 className="text-4xl font-serif mb-4">
          Simple & transparent pricing
        </h2>
        <p className="text-2xl font-serif text-gray-600 mb-8">
          for all business sizes
        </p>
        
        <div className="flex justify-center items-center space-x-4 mb-12">
          <button
            className={`px-4 py-2 rounded-lg ${
              billingPeriod === 'monthly' ? 'bg-gray-100' : ''
            }`}
            onClick={() => setBillingPeriod('monthly')}
          >
            Monthly billing
          </button>
          <button
            className={`px-4 py-2 rounded-lg ${
              billingPeriod === 'annual' ? 'bg-gray-100' : ''
            }`}
            onClick={() => setBillingPeriod('annual')}
          >
            Annual billing
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <PricingCard
          title={pricingData.basic.title}
          price={billingPeriod === 'monthly' ? pricingData.basic.monthlyPrice : pricingData.basic.annualPrice}
          period={billingPeriod === 'monthly' ? 'month' : 'year'}
          features={pricingData.basic.features}
        />
        <PricingCard
          title={pricingData.business.title}
          price={billingPeriod === 'monthly' ? pricingData.business.monthlyPrice : pricingData.business.annualPrice}
          period={billingPeriod === 'monthly' ? 'month' : 'year'}
          features={pricingData.business.features}
          isPopular
        />
        <PricingCard
          title={pricingData.enterprise.title}
          price={billingPeriod === 'monthly' ? pricingData.enterprise.monthlyPrice : pricingData.enterprise.annualPrice}
          period={billingPeriod === 'monthly' ? 'month' : 'year'}
          features={pricingData.enterprise.features}
        />
      </div>
    </div>
  );
};

export default PricingSection;
